<template>
    <v-dialog
        v-model="isShowModal"
        :max-width="maxWidth"
        :persistent="persistent"
        :fullscreen="fullscreen"
        :scrollable="scrollable"
        :transition="transition"
        :scrim="scrim"
        :retain-focus="retainFocus"
    >
        <template v-slot:activator="{props}">
            <slot name="activator" :props="props" />
        </template>
        <v-card :loading="loading" :class="contentClass" class="py-3 px-2">
            <template v-slot:loader>
                <v-progress-linear v-if="loading" color="primary" indeterminate />
            </template>
            <v-card-title class="d-flex justify-space-between gc-2 text-wrap">
                <slot name="title" />
                <v-spacer />
                <v-icon data-cy="close" size="x-small" class="ml-auto" @click="isShowModal = false"> mdi-close </v-icon>
            </v-card-title>
            <v-card-subtitle v-if="subtitle">{{ subtitle }}</v-card-subtitle>
            <v-card-text>
                <slot name="content" />
                <slot />
            </v-card-text>
            <v-card-actions v-if="!hideActions">
                <v-btn v-if="!hideCancel" color="inherit" data-cy="cancel" @click="isShowModal = false">
                    {{ $t('cancel') }}
                </v-btn>
                <slot name="btns" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
    // TODO [P3] Need refactoring fallthrough attributes
    const {
        scrim = true,
        maxWidth = 600,
        scrollable = true,
        retainFocus = true,
    } = defineProps<{
        maxWidth?: number | string
        persistent?: boolean
        scrollable?: boolean
        hideCancel?: boolean
        hideActions?: boolean
        fullscreen?: boolean
        subtitle?: string
        transition?: string
        loading?: boolean
        contentClass?: string | object
        scrim?: boolean
        retainFocus?: boolean
    }>()
    const isShowModal = defineModel<boolean>()
</script>
